import { sortBy } from 'lodash';
import { RootState } from '..';
import { SegmentsState } from './segments.reducer';

export const selectSegments = (state: RootState) =>
  sortBy(state.segments.segments, 'name');

export const selectSegmentsByProductType = (
  state: SegmentsState,
  productTypeId?: number
) =>
  sortBy(
    state.segments.filter(segment => segment.productTypeId === productTypeId),
    'name'
  );

export const selectSegmentErrors = (state: RootState) => state.segments.errors;
